import { render, staticRenderFns } from "./editStoreAds.vue?vue&type=template&id=152f63db"
import script from "./editStoreAds.vue?vue&type=script&lang=js"
export * from "./editStoreAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports